<template>
    <div class="impact-report-wizard-body">
        <span class="headline">
            Over the past year, what initiatives were you using Pendo to drive?
        </span>
        <div class="action-cards">
            <template
                v-for="card in actionCards"
                :key="card.title">
                <pendo-action-card
                    :title="card.title"
                    :description="card.description"
                    :class="{ 'secondary-card': card.buttonType === 'secondary' }">
                    <template #actions>
                        <pendo-button
                            theme="app"
                            :type="card.buttonType"
                            :label="card.buttonLabel"
                            data-cy="select-initiative-button"
                            :prefix-icon="card?.buttonIcon ?? null"
                            @click="onClick(card.buttonType)" />
                    </template>
                </pendo-action-card>
            </template>
        </div>
    </div>
</template>

<script>
import { PendoActionCard, PendoButton } from '@pendo/components';

export default {
    name: 'SelectInitiatives',
    components: {
        PendoActionCard,
        PendoButton,
    },
    emits: ['nextStep'],
    data () {
        return {
            actionCards: [
                {
                    title: 'Improve onboarding effectiveness',
                    description:
                        'Help new users successfully adopt your product by measuring key actions, providing timely guidance, and accelerating user time-to-value.',
                    buttonType: 'primary',
                    buttonLabel: 'Select initiative',
                },
                {
                    title: 'Drive better feature adoption ',
                    description:
                        'Increase user awareness and adoption of key features by analyzing user behavior, delivering relevant guidance, and measuring engagement.',
                    buttonType: 'secondary',
                    buttonLabel: 'Notify me when available',
                    buttonIcon: 'bell',
                },
                {
                    title: 'Deflect support tickets',
                    description:
                        'Reduce support volume and increase user self-sufficiency by identifying common user issues, proactively providing solutions, and measuring guide effectiveness.',
                    buttonType: 'secondary',
                    buttonLabel: 'Notify me when available',
                    buttonIcon: 'bell',
                },
            ],
        };
    },
    methods: {
        onClick (buttonType) {
            if (buttonType === 'primary') {
                this.$emit('nextStep');
            }
        },
    },
};
</script>

<style lang="less" scoped>
.impact-report-wizard-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    span.headline {
        font-weight: 600;
        font-family: 'Inter';
        margin: 40px auto;
        text-align: center;
        font-size: 22px;
    }
    .hidden {
        .pendo-input__field {
            border: none;
        }
    }
    :deep(.pendo-form-item__label) {
        display: flex;
        align-items: center;
        font-weight: 400;
        .info-icon {
            margin-left: 4px;
        }
    }
    :deep(.pendo-form-item__content) {
        margin: 12px 0 0 22px;
    }
    .optional-question-toggle + .event-selector,
    .optional-question-toggle + .pendo-multiselect {
        margin-top: 14px;
    }
    .action-cards {
        display: flex;
        gap: 16px;
        padding: 24px;
        border: 1px solid var(--palette-gray-40);
        background-color: var(--palette-gray-0);
        border-radius: 3px;
    }
    :deep(.secondary-card) {
        background-color: var(--palette-gray-10);
    }
}
</style>
